<app-navigation></app-navigation>

<section class="section section-square-pattern">
  <div class="container px-tablet-0">
    <div class="row no-gutters">
      <div class="column-12 column-desktop-large-8 mx-desktop-auto">
        @if (pageTitle$ | async; as title) {
          <app-page-header [pageTitle]="title"></app-page-header>
        }
        <router-outlet #outlet="outlet"></router-outlet>
        @if (loadFailed) {
          <div><h2>Oeps! Er is iets fout gegaan.</h2></div>
        }
      </div>
    </div>
  </div>
</section>
